import { api } from './requestGraphql.js'

const getSettings = async () => {

  try {

    const res = await api.post(
      '', {
        query: `
          {
           getSettings {
                id
                name
                settings
           }
          }
        `,
      }
    );
    return res.data.data.getSettings;
  } catch (e) {
    console.log(e)
  }
};

const getManagerSettingsId = async () => {

    try {

        const res = await api.post(
            '', {
                query: `
          {
           getManagerSettingsId
          }
        `,
            }
        );
        return res.data.data.getManagerSettingsId;
    } catch (e) {
        console.log(e)
    }
};

const createSettings = async ({name, settings}) => {
    console.log('name', name);
    console.log('settings', settings);
    const settingsStr = JSON.stringify(settings).replace(/"/g, '\\"');
    try {
        const res = await api.post(
            '',
            {
                query: `
                  mutation {
                    createSettings(name: "${name}", settings: "${settingsStr}") {
                      id
                      name
                      settings
                    }
                  }
                `,
            }
        );
        return res.data.data.createSettings;
    } catch (e) {
        console.error(e);
    }
};

const updateSettings = async ({name, settings}) => {
    const settingsStr = JSON.stringify(settings).replace(/"/g, '\\"');
    try {
        const res = await api.post(
            '',
            {
                query: `
                  mutation {
                    updateSettings(name: "${name}", settings: "${settingsStr}") {
                      id
                      name
                      settings
                    }
                  }
                `,
            }
        );
        return res.data.data.updateSettings;
    } catch (e) {
        console.error(e);
    }
};

const resetManagerSettings = async () => {
    try {
        const res = await api.post(
            '',
            {
                query: `
                  mutation {
                    resetManagerSettings
                  }
                `,
            }
        );
        return res.data.data.resetManagerSettings;
    } catch (e) {
        console.error(e);
    }
};

export default {
    getSettings,
    getManagerSettingsId,
    createSettings,
    updateSettings,
    resetManagerSettings
}
